<div class="product-options-container">
  <render-select
    #sizeSelectorComponent
    *ngIf="hasToDisplayProductSizesSelector && !!product?.colors?.length"
    [defaultValue]="piece?.settings?.general?.titleSize"
    (valueChange)="onSizeSelected($event)">
    <div
      *ngIf="hasToDisplayProductSizesAdditionalInfo && product?.additionalInfo"
      class="size-recommendation">
      <render-wysiwyg
        [html]="product!.additionalInfo! | additionalInfo:piece!"
        [country]="country"
        [lang]="lang"
        [piece]="piece">
      </render-wysiwyg>
    </div>
    <ng-container
        *ngFor="let size of (product.colors | colorSizes: imageDetails?.colorId); trackBy: trackBySize">
      <render-select-option
        [text]="selectedSize"
        [isDisabled]="size.visibilityValue !== 'SHOW'"
        [value]="product.colors[0].sizes!.length > 1 ? size.name : piece?.settings?.general?.oneSizeText">
        {{ product.colors[0].sizes!.length > 1 ? size.name : piece?.settings?.general?.oneSizeText }}
        <div
          *ngIf="hasToDisplayProductSizesLastUnitsWarning"
          class="threshold-label">
            <render-wysiwyg
              [html]="size.typeThreshold | thresholdLabel:'UMBRAL_BAJO':piece!:size.visibilityValue !== 'SOLD_OUT'"
              [country]="country"
              [lang]="lang"
              [piece]="piece">
            </render-wysiwyg>
          </div>
        <div
          *ngIf="hasToDisplayViewSimilarProducts"
          class="view-similar"
          (click)="$event.stopPropagation(); onViewSimilarClick(size)">
            <render-wysiwyg
              [html]="piece! | viewSimilarProducts:size.visibilityValue === 'SHOW'"
              [country]="country"
              [lang]="lang"
              [piece]="piece">
            </render-wysiwyg>
          </div>
      </render-select-option>
    </ng-container>
  </render-select>

  <button
    class="product-cart"
    (click)="$event.stopPropagation(); onProductCartClick()">
    <div
      *ngIf="piece!.settings?.general?.productAddToCartText"
      class="wysiwyg">
      <render-wysiwyg
        [html]="piece!.settings!.general!.productAddToCartText"
        [country]="country"
        [lang]="lang"
        [piece]="piece">
      </render-wysiwyg>
    </div>
    <svg
      *ngIf="piece!.settings?.general?.displayProductIconAddToCart"
      viewBox="0 0 16 16">
      <path d="M0 .76V2.4h1.06l3.78 9.07a.8.8 0 0 0 .76.53h7.18c.38 0 .64-.22.75-.53l2.42-6.42a.8.8 0 0 0-.75-1.06H3.48L2.34 1.29A.8.8 0 0 0 1.6.76zM4.16 5.6h9.9l-1.81 4.8H6.12zm2.65 7.98a1.21 1.21 0 1 0 0 2.42 1.21 1.21 0 0 0 0-2.42zm4.76 0a1.21 1.21 0 1 0 0 2.42 1.21 1.21 0 0 0 0-2.42z"/>
    </svg>
  </button>
</div>

